import type { SVGProps } from 'react'

export function Merge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.875 9.99853H14.375M14.375 9.99853L12.4219 8.00987M14.375 9.99853L12.4219 11.9872M6.25 15V14.375C6.25 10.625 9.375 10 11.875 10C9.375 10 6.25 9.375 6.25 5.625V5M5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V5C17.5 3.61929 16.3807 2.5 15 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
